import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_PAGEACTION_TYPE, ENUM_TRADEOF_CODE, linksUrl, URIEncrypt } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/packetTransferSlice";

const MixPacketTransferMaster = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode, isMultipleCompany } = useSelector((state) => state.company);
    const { strdtype, sptype } = useParams();
    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")
    const [entryLabel, setEntryLabel] = useState("")
    const [selBillType, setSelBillType] = useState("Q")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState("")


    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough]
        if (!params.includes(String(strdtype))
            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(sptype))
            navigate(linksUrl.dashboard)

        if (strdtype && strdtype != "" && sptype && sptype != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_pktType = ''
            let t_trdtype = strdtype.toLowerCase()

            if (sptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'

            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish "
                setnaviCode(linksUrl.packetTrasnferEntry.polishStock)
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough "
                setnaviCode(linksUrl.packetTrasnferEntry.roughStock)
            }


            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            filterData({
                data: {
                    compcode: compCode.join(","),
                    bill_type: selBillType,
                    trade_of: t_tradeof,
                    pkt_type: t_pktType == 'SNG' ? 'SNG' : '',
                    ac_year: 1

                }
            })


        }

    }, [sptype, strdtype])
    const {
        data: challanData = [],
        isLoading,
        isError,
        mutate: filterData
        // refetch,
    } = usePost({
        url: apiRoute.packetTransferEntry.getChallanSummary,
        queryKey: "fetchChallanSummary",
    });

    const onSuccessDelete = () => {
        // refetch();
        toast.success("Challan Deleted", { position: "top-center" });
        setItemToDelete("")
        filterData({
            data: {
                compcode: compCode.join(","),
                bill_type: selBillType,
                trade_of: selTradeOf,
                pkt_type: selPktType == 'SNG' ? 'SNG' : '',
                ac_year: 1

            }
        })
    };

    const { mutate: deleteChallan } = usePost({
        queryKey: "deleteChallan",
        url: apiRoute.packetTransferEntry.deletePktChalData,
        successMessage: "Deleted successfully",
        onSuccess: onSuccessDelete,
        onError: (err) => toast.error("Delete failed"),
    });

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
                deleteChallan({
                    data: {
                        compcode: itemToDelete.compcode,
                        dy: 1, // Or use actual DY if needed
                        bill_type: selBillType,
                        transaction_id: itemToDelete.transactionid,
                        detail_id: 0
                    }
                });
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setDetailParams(itemToEdit));
                dispatch(setNewEntryMode(false));
                navigate(naviCode + "/" + strdtype + "/" + sptype + linksUrl.packetTrasnferEntry.createmixEntry);
            }
        } else {
            // setIsConfirmOpen(false);
            setItemToDelete(""); // 👈 reset selection
            setItemToEdit("")
            setPageActionType("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(naviCode + "/" + strdtype + "/" + sptype + linksUrl.packetTrasnferEntry.createmixEntry);
    };

  
    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Chal No", uid: "Chal_No", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Party Name", uid: "AC_DESC", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Purpose", uid: "purpose", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Total Pkt", uid: "PktNoCount", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Total Weight", uid: "TotalWeight", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                const obj = {
                    comp_code: row.CompCode,
                    bill_type: selBillType,
                    transaction_id: row.TransactionId,
                    trade_of: row.Trade_Of,
                }


            }, // Use the separate handler function
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                setItemToDelete({ transactionid: row.TransactionId, compcode: row.CompCode, tradeof: row.Trade_Of })
                //  handleDeleteClick(row.TransactionId);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isLoading) { return <LoadingCard /> }
    if (isError) { return <ErrorCard /> }

    return (
        <div>
            <MainContainer pageName={`Packet Transfer ${entryLabel} Mix`} breadcrumbs={["Packet Transfer", entryLabel, "Mix"]}>
                <div className="text-right mb-4">
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}
                    >
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Chal_No", "AC_DESC", "purpose", "PktNoCount", "TotalWeight"]}
                    data={challanData}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    downloadFileName="PKT-Transfer-Report"
                    id="TransactionId"
                />
            </MainContainer>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}

        </div>
    );
}

export default MixPacketTransferMaster